import React, { useState, useEffect, useRef } from "react";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  AlertTitle,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import Alert from "@mui/material/Alert";
import { DateTime } from "luxon";
import {
  flushPendingUploads,
  guardarFichajeLocal,
  hasPendingUploads,
  marcarOnline,
} from "../helpers/cron";

const Alert2 = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const isNetworkError = (error) => {
  if (!error) return true;
  if (error.code === "ECONNABORTED") return true;
  if (!error.response) return true;
  return false;
};

const Fichaje = () => {
  const navigate = useNavigate();

  let { lat, lon } = useParams();

  const [openError, setOpenError] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(true);
  const [messageError, setMessageError] = useState("");
  const buttonRef = useRef(null);

  const errorAx = (error) => {
    try {
      if (
        error.response.data.message === undefined ||
        error.response.data.message === ""
      ) {
        throw Error("");
      }
      setMessageError(error.response.data.message);
    } catch (catcherror) {
      setMessageError(error.message);
    } finally {
      setOpenBackdrop(false);
      setOpenError(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };

  const handleSubmit = async () => {
    setOpenBackdrop(true);
    const fecha = DateTime.now().toUTC().toString();

    if (window.navigator.onLine) {
      try {
        if (await hasPendingUploads()) {
          await flushPendingUploads();
        }

        const [, message, codeMessage] = await marcarOnline(lat, lon, fecha);
        return navigate(`/?message_${codeMessage}=${message}`);
      } catch (error) {
        if (!isNetworkError(error)) {
          errorAx(error);
          return;
        }
        // Fallo de red: continuar con guardado offline
      }
    }

    try {
      const [, message, codeMessage] = await guardarFichajeLocal(lat, lon, fecha);
      return navigate(`/?message_${codeMessage}=${message}`);
    } catch (error) {
      errorAx(error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("tokenUsuario");

    if (token === undefined || token === "" || token === null) {
      return navigate("/login");
    }

    setOpenBackdrop(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      buttonRef.current.scrollIntoView({ behavior: "smooth" });
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lon),
  };

  const containerStyle = {
    width: "100%",
    height: "600px",
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
      marginX={4}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {window.navigator.onLine ? (
        window.google === undefined ? (
          <LoadScript googleMapsApiKey="AIzaSyA5GV1fUQvk2V93M97f6qlRNByN50JEzqg">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={13}
            >
              <MarkerF position={center} />
            </GoogleMap>
          </LoadScript>
        ) : (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={13}
          >
            <MarkerF position={center} />
          </GoogleMap>
        )
      ) : (
        <Alert severity="info" style={{ width: "90%" }}>
          <AlertTitle>Esta es tu locación</AlertTitle>
          Latitud: <strong>{lat}</strong> <br />
          Longitud: <strong>{lon}</strong>
        </Alert>
      )}

      <Button
        variant="contained"
        color="primary"
        ref={buttonRef}
        mt={1}
        fullWidth
        sx={{ margin: 2, maxWidth: 500 }}
        onClick={handleSubmit}
      >
        Guardar
      </Button>

      <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
        <Alert2 onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {messageError}
        </Alert2>
      </Snackbar>
    </Box>
  );
};

export default Fichaje;
